/* ============================================================================
  Social Feed Popup — ported from client theme.js (SocialFeedPopup class).
  Extends Freshwater's ModalDialog (defined in global.js).
============================================================================== */
class SocialFeedPopup extends ModalDialog {
  constructor() {
    super();
    this.activePost = null;
    this.videoPlaying = false;

    this.addEventListener('click', (e) => {
      if (e.target.closest('.js-sm-feed-popup-left-arrow')) this.switchSlides('left');
      if (e.target.closest('.js-sm-feed-popup-right-arrow')) this.switchSlides('right');
    });
  }

  show(opener) {
    const originalPauseAllMedia = window.pauseAllMedia;
    window.pauseAllMedia = () => {};

    super.show(opener);
    const postId = opener.getAttribute('data-post-id');
    if (postId === 'post-placeholder') return;
    this.setActivePost(postId);

    setTimeout(() => {
      window.pauseAllMedia = originalPauseAllMedia;
    }, 100);
  }

  hide() {
    if (this.activePost) this.pauseVideo();
    super.hide();
  }

  setActivePost(postId) {
    const relevantPost = this.querySelector(`[data-post-id="${postId}"]`);
    if (!relevantPost) return;
    if (this.activePost) this.activePost.classList.remove('is-active');
    relevantPost.classList.add('is-active');
    this.activePost = relevantPost;
    this.playVideo();
  }

  playVideo() {
    const video = this.activePost && this.activePost.querySelector('video');
    if (!video) return;

    video.loop = true;
    video.muted = false;
    video.playsInline = true;

    video.addEventListener('pause', () => {
      if (this.videoPlaying) video.play();
    });

    video.addEventListener('ended', () => {
      video.currentTime = 0;
      video.play();
    });

    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise
        .then(() => { this.videoPlaying = true; })
        .catch(() => {
          video.muted = true;
          video.play().then(() => { this.videoPlaying = true; });
        });
    }
  }

  pauseVideo() {
    const video = this.activePost && this.activePost.querySelector('video');
    if (!video) return;
    this.videoPlaying = false;
    video.pause();
  }

  switchSlides(direction = 'right') {
    const newPost =
      direction === 'left'
        ? this.activePost.previousElementSibling
        : this.activePost.nextElementSibling;
    if (!newPost) return;

    this.pauseVideo();
    this.activePost.classList.remove('is-active');
    newPost.classList.add('is-active');
    this.activePost = newPost;
    this.playVideo();
  }
}

customElements.define('social-feed-popup', SocialFeedPopup);
